import { useEffect, useState } from "react";
import { useSession } from "./session";

/** Value that only updates after the user stops typing. */
export function useDebounced<T>(value: T, ms = 250): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setV(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return v;
}

/** The active clinic's locale, currency and time zone, for formatting. */
export function useClinicFormat() {
  const { session } = useSession();
  const t = session?.activeTenant;
  return { locale: t?.locale ?? "en-IN", currency: t?.currencyCode ?? "INR", timeZone: t?.timeZone ?? "UTC", country: t?.countryCode ?? "IN" };
}
